import React from "react";
import { Alert, AlertTitle } from "@mui/material";

const colorClasses = {
  error: {
    border: "border-red-400",
    text: "text-red-700",
  },
  success: {
    border: "border-green-400",
    text: "text-green-700",
  },
  warning: {
    border: "border-yellow-400",
    text: "text-yellow-700",
  },
  info: {
    border: "border-blue-400",
    text: "text-blue-700",
  },
  note: {
    border: "border-blue-800",
    text: "text-blue-800",
  },
};

const BaseAlert = ({
  title,
  message,
  type = "info",
  closable = false,
  onClose,
}) => {
  const colors = colorClasses[type] || colorClasses.info;

  return (
    <Alert
      severity={type}
      variant="standard"
      onClose={closable ? onClose : undefined}
      className={`rounded-lg text-sm px-4 py-2 border ${colors.border}`}
      sx={{
        "& .MuiAlert-message": {
          padding: 0,
          margin: 0,
        },
        "& .MuiAlert-icon": {
          alignSelf: "flex-start",
          marginTop: "-6px",
          "& svg": {
            fontSize: "20px",
          },
        },
      }}
    >
      {title && (
        <AlertTitle className={`font-normal text-sm mb-1 ${colors.text}`}>
          {title}
        </AlertTitle>
      )}
      <p className={`${colors.text}`}>{message}</p>
    </Alert>
  );
};

export default BaseAlert;
